import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetContactPrimaryAccount as GetContactPrimaryAccountQuery,
    GetContactPrimaryAccountVariables,
    ContactPrimaryAccountFragment,
} from 'nutshell-graphql-types';

import GET_CONTACT_PRIMARY_ACCOUNT from '../queries/get-contact-primary-account.graphql';

export function useGetContactPrimaryAccount(
    contactId: string,
    skip: boolean = false
): {
    contactPrimaryAccount: ContactPrimaryAccountFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<
        GetContactPrimaryAccountQuery,
        GetContactPrimaryAccountVariables
    >(GET_CONTACT_PRIMARY_ACCOUNT, {
        variables: {id: contactId},
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
        skip,
    });

    return {
        contactPrimaryAccount: data?.contact?.primaryAccount ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
